import { render, staticRenderFns } from "./DeviationGrid.vue?vue&type=template&id=ecd26fb4&scoped=true&"
import script from "./DeviationGrid.vue?vue&type=script&lang=js&"
export * from "./DeviationGrid.vue?vue&type=script&lang=js&"
import style0 from "./DeviationGrid.vue?vue&type=style&index=0&id=ecd26fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd26fb4",
  null
  
)

/* custom blocks */
import block0 from "./DeviationGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports